import i18next from "i18next";

import config from "@/config";
import { defaultDateFormat } from "@/core/date";
import { defaultCurrencyFormat } from "@/core/number";
import { InvoiceCategory, InvoiceDetails, SearchableInvoice } from "@/shared/domain";

import { getSpApi, pagedRequestConfig, requestConfig } from "./apiRoot";
import { UrlManager } from "./UrlManager";

// Swagger: https://ibpcsrcdev01.portima.net/mybrokerapi/swagger/index.html

export const searchableInvoiceMapper = (source: MyBrokerApi.Invoice[]): SearchableInvoice[] => {
    return source?.map((invoice) => ({
        ...invoice,
        amountString: defaultCurrencyFormat(invoice.amount, i18next.language),
        dateString: defaultDateFormat(invoice.date),
    }));
};

export type InvoicesQueryParameters = Paths.ApiInvoice.Get.QueryParameters;

export const getRawInvoices = async (
    requestParams: InvoicesQueryParameters = {},
): Promise<MyBrokerApi.InvoicePayload> => {
    const axiosRequestConfig = pagedRequestConfig<InvoicesQueryParameters>({ params: requestParams });
    const { data } = await getSpApi().get<MyBrokerApi.InvoicePayload>(UrlManager.invoices(), axiosRequestConfig);
    return data;
};

export const getInvoices = async (
    requestParams: InvoicesQueryParameters = {},
    category: string = InvoiceCategory.ALL,
): Promise<MyBrokerApi.InvoicePayload> => {
    if (category !== InvoiceCategory.ALL) {
        requestParams.category = category as MyBrokerApi.InvoiceStatus;
    }
    return await getRawInvoices(requestParams);
};

export const getInvoicesLazy = async (
    requestParams: InvoicesQueryParameters = {},
): Promise<MyBrokerApi.InvoicePayload> => {
    return await getRawInvoices(requestParams);
};

export const invoiceDetailsMapper = (source: MyBrokerApi.InvoiceDetails): InvoiceDetails => {
    return {
        ...source,
    };
};

export const getRawInvoiceDetails = async (
    invoiceId: number,
    policyholderId: number,
): Promise<MyBrokerApi.InvoiceDetails> => {
    const axiosRequestConfig = requestConfig<Paths.ApiInvoice$Id.Get.QueryParameters>({
        params: {
            policyholderId,
        },
    });

    const { data } = await getSpApi().get<MyBrokerApi.InvoiceDetails>(
        UrlManager.invoice(invoiceId),
        axiosRequestConfig,
    );
    return data;
};

export const getInvoiceDetails = async (invoiceId: number, policyholderId: number): Promise<InvoiceDetails> => {
    const data = await getRawInvoiceDetails(invoiceId, policyholderId);
    return invoiceDetailsMapper(data);
};

export const getInvoicePdfUrl = (invoiceId: number, ibpAclId: number): string => {
    return `${config.SPAPI_URL}/api/document/invoice/${invoiceId}?ibpAclId=${ibpAclId}`;
};
